import { EventCategory, EventsActionType } from '../types/eventsTypes';

export const fetchEventsAction = (status?: 'ACTIVE' | 'DRAFT' | 'ALL') => ({
  type: EventsActionType.FETCH_EVENTS,
  payload: { status },
});

export const fetchEventsPropertiesAction = () => ({
  type: EventsActionType.FETCH_EVENT_PROPERTIES,
});

export const fetchEventDetailsAction = (id: string) => ({
  type: EventsActionType.FETCH_EVENT_DETAILS,
  payload: id,
});

export const setEventsCategoryFilter = (category: EventCategory | '') => ({
  type: EventsActionType.SET_EVENTS_CATEGORY_FILTER,
  payload: category,
});

export const setEventsTimelineFilter = (timeline: string) => ({
  type: EventsActionType.SET_EVENTS_TIMELINE_FILTER,
  payload: timeline,
});

export const setEventsFavoritesFilter = (favourites: boolean) => ({
  type: EventsActionType.SET_EVENTS_FAVORITES_FILTER,
  payload: favourites,
});

export const setEventsSortDesc = (sortDesc: boolean) => ({
  type: EventsActionType.SET_EVENTS_SORT_DESC,
  payload: sortDesc,
});

export const fetchEventTitles = (title: string) => ({
  type: EventsActionType.FETCH_EVENT_TITLES,
  payload: title,
});

export const fetchEventSessions = (id: string) => ({
  type: EventsActionType.FETCH_EVENT_SESSIONS,
  payload: id,
});

export const fetchSessionsDetails = (id: string) => ({
  type: EventsActionType.FETCH_SESSION_DETAILS,
  payload: id,
});
